const n = {
  classPrefix: "nut-icon",
  tag: "i",
  fontClassName: "nutui-iconfont"
};
export {
  n as globalConfig
};
